import type {ProjectsGlobal} from '~/payload-types'

export function useProjectsMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'projectsGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as ProjectsGlobal
  }

  return {fetch}
}
